function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { T, useTranslate } from 'shared/helper/translate';
import ModalConfirm from 'shared/components/ModalConfirm';
import OrderFormHeader from 'researcher/order-form/order/components/OrderFormHeader';
var CurrencySelect = function CurrencySelect(_ref) {
  var handleCurrencySubmission = _ref.handleCurrencySubmission;
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  var _useState = useState('USD'),
    _useState2 = _slicedToArray(_useState, 2),
    currency = _useState2[0],
    setCurrency = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    disabled = _useState4[0],
    setDisabled = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    currencyConfirm = _useState6[0],
    setCurrencyConfirm = _useState6[1];
  var currencies = useSelector(function (_ref2) {
    var payment = _ref2.payment;
    return payment.currencies;
  });
  var orderCurrency = useSelector(function (_ref3) {
    var order = _ref3.order;
    return order.order.currency;
  });
  var rowCurrencies = currencies.filter(function (currency) {
    return currency.isoCode !== 'CNY';
  });
  var handleCurrencySelected = function handleCurrencySelected() {
    setDisabled(true);
    handleCurrencySubmission(currency).then(function () {
      setDisabled(false);
    });
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, currencyConfirm ? /*#__PURE__*/React.createElement(ModalConfirm, {
    appElement: "#researcher-app",
    close: function close() {
      return setCurrencyConfirm(false);
    },
    show: true,
    yesAction: handleCurrencySelected,
    title: "currency-confirmation-modal-title"
  }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(T, {
    source: "currency-confirmation-modal-desc"
  }))) : null, /*#__PURE__*/React.createElement(OrderFormHeader, {
    title: "select-currency-header",
    intro: "select-currency-desc",
    iconClassName: "fa-money",
    className: "ms-0"
  }), rowCurrencies.map(function (currency) {
    return /*#__PURE__*/React.createElement("div", {
      className: "row",
      key: currency.isoCode
    }, /*#__PURE__*/React.createElement("label", {
      className: "form-check-inline"
    }, /*#__PURE__*/React.createElement("input", {
      className: "form-check-input me-2",
      type: "radio",
      name: "currency",
      onChange: function onChange() {
        return setCurrency(currency.isoCode);
      },
      value: currency.isoCode,
      defaultChecked: orderCurrency ? orderCurrency.isoCode === currency.isoCode : currency.isoCode === 'USD'
    }), /*#__PURE__*/React.createElement(T, {
      source: currency.shortName
    })));
  }), /*#__PURE__*/React.createElement("div", {
    className: "row my-3 mx-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement("button", {
    "aria-label": t('Choose Currency'),
    onClick: function onClick() {
      return setCurrencyConfirm(true);
    },
    type: "submit",
    className: "btn btn-primary",
    disabled: disabled
  }, /*#__PURE__*/React.createElement(T, {
    source: "Choose Currency"
  })), disabled ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    className: "ms-1",
    icon: "fa-solid fa-spinner-scale",
    spin: true
  }) : null)));
};
export default CurrencySelect;